"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.couponDetails_bff = exports.couponAction_bff = void 0;
var tslib_1 = require("tslib");
var index_1 = require("../../common/index");
var common_1 = require("../../common");
var interfaces_1 = require("../../common/interfaces");
var couponAction_bff = function (data) {
    var coupon = data.coupon, cartId = data.cartId;
    var operationName = '';
    var bffVariables = {
        cartId: cartId,
    };
    if (coupon.command === 'ADD') {
        bffVariables['promotions'] = [
            {
                code: coupon.code,
            },
        ];
        operationName = interfaces_1.GraphQLOperations.APPLY_COUPON;
    }
    else {
        bffVariables['promotionIds'] = [coupon.code];
        operationName = interfaces_1.GraphQLOperations.REMOVE_COUPON;
    }
    return (0, index_1.sendBFFCall)(operationName, bffVariables, common_1.cartCheckoutGraphRequestToCheggResponse, ['addPromotions_Internal', 'removePromotions_Internal']).catch(function (error) { return JSON.parse(error.message); });
};
exports.couponAction_bff = couponAction_bff;
var couponDetails_bff = function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        return [2 /*return*/, (0, index_1.sendBFFCall)(interfaces_1.GraphQLOperations.COUPON_DETAILS, {
                input: params,
            }).catch(function (error) { return JSON.parse(error.message); })];
    });
}); };
exports.couponDetails_bff = couponDetails_bff;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/couponAPI/bff/index.js
// module id = 3398
// module chunks = 11